module.exports = __webpack_public_path__ + "static/success-banner-desktop-0ba3b44ed29462634eebaf4644c40cf0.jpg";